import { FC } from 'react';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../../../../components/ui/Select';
import { Textarea } from '../../../../components/ui/Textarea';
import { OrderCancellationReason } from '../../../../types';

interface Props {
    description: string;
    reasons: OrderCancellationReason[];
    reasonId: string;
    comment: string;
    selectedReason?: OrderCancellationReason;
    disabled: boolean;
    onReasonChange: (reasonId: string) => void;
    onCommentChange: (comment: string) => void;
}

export const OrderCancellationReasonFields: FC<Props> = ({
    description,
    reasons,
    reasonId,
    comment,
    selectedReason,
    disabled,
    onReasonChange,
    onCommentChange,
}) => (
    <div className="space-y-4">
        <p className="text-sm text-muted-foreground">{description}</p>

        <Select
            value={reasonId}
            onValueChange={onReasonChange}
            disabled={disabled}
        >
            <SelectTrigger>
                <SelectValue placeholder="Оберіть причину" />
            </SelectTrigger>
            <SelectContent side="bottom" sideOffset={4} avoidCollisions={false}>
                {reasons.map((reason) => (
                    <SelectItem key={reason.id} value={String(reason.id)}>
                        {reason.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>

        {selectedReason && (
            <Textarea
                value={comment}
                onChange={(event) => onCommentChange(event.target.value)}
                placeholder="Опишіть причину"
                disabled={disabled}
            />
        )}
    </div>
);
